import { client } from '@api/client';

export async function getChatHistory(limit?: number, cursor?:number) {
    return client.GET('/chat-history', {
        params: {
            query: {
                cursor,
                limit,
            },
        },
    });
}
